import React from 'react';
import styled, { css } from 'styled-components';

export default props => {

    return (
        <Container
            cols={props.cols}
            rows={props.rows}
            small={props.small} 
            smaller={props.smaller} 
            style={props.style} 
            className={props.className}
            id={props.id} 
        >
            {props.children}
        </Container>
    )
}


const Container = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    
    ${props => props.rows && css`
        -ms-grid-rows: (1fr)[15];
        grid-template-rows: repeat(15, 1fr);
    `}

    @media (min-width: 820px) {
        -ms-grid-columns: (1fr)[5];
        grid-template-columns: repeat(5, 1fr);
        
        ${props => props.rows && css`
            -ms-grid-rows: (1fr)[15];
            grid-template-rows: repeat(15, 1fr);
        `}
    }

    width:100%;
    max-width:1260px;
    margin: 0 auto;
    position:relative;
    @media (max-width: 1300px) {
        padding: 0 20px;
    }
    @media (max-width: 767px) {
        padding: 0;
    }
    ${props => props.medium && css`
        max-width: 1024px;
        @media (max-width: 1064px) {
            padding: 0 20px;
        }
    `}


    ${props => props.small && css`
        max-width: 960px;
        @media (max-width: 1000px) {
            padding: 0 20px;
        }
    `}
    
    ${props => props.smaller && css`
        max-width: 780px;
        @media (max-width: 820px) {
            padding: 0 20px;
        }
    `}
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/grid/Grid.js